import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, GitCompare, Check } from "lucide-react";
import NavBar from "@/NavBar";
import Footer from "@/Footer";
import { APPS, cleanName } from "@/apps";

export const Compare = () => (
  <div className="hi-bg hi-grain min-h-screen">
    <NavBar />
    <div className="relative z-[2] max-w-6xl mx-auto px-5 py-10 md:py-14">
      <Link to="/" data-testid="compare-back" className="hi-cta inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold hi-body bg-white/5 border border-white/10 text-white/80 hover:bg-white/10">
        <ArrowLeft size={16} strokeWidth={2.5} /> Back to Suite
      </Link>

      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="mt-8">
        <div className="flex items-center gap-3">
          <span className="grid place-items-center w-11 h-11 rounded-xl bg-[#3b9bff]/15 text-[#3b9bff] border border-[#3b9bff]/30"><GitCompare size={20} /></span>
          <h1 className="hi-serif text-3xl md:text-4xl text-[#f3ead4]">Compare Apps</h1>
        </div>
        <p className="hi-body text-white/75 mt-3 max-w-2xl">
          Every Herrell Interactive app at a glance — what it's for, its category, and its flagship AI assistant.
        </p>

        <div className="mt-8 overflow-x-auto hi-card p-0" data-testid="compare-table">
          <table className="w-full text-left border-collapse min-w-[720px]">
            <thead>
              <tr className="border-b border-white/10">
                {["App", "Category", "Status", "Flagship feature", "Highlights"].map((h) => (
                  <th key={h} className="hi-body text-[11px] uppercase tracking-wider text-white/55 font-semibold px-5 py-4">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {APPS.map((app) => (
                <tr key={app.id} data-testid={`compare-row-${app.id}`} className="border-b border-white/[0.06] hover:bg-white/[0.03] transition-colors">
                  <td className="px-5 py-4">
                    <Link to={`/${app.slug}`} className="flex items-center gap-3 group">
                      <img src={app.logo} alt={app.name} className="w-10 h-10 rounded-lg object-cover" />
                      <span className="hi-body font-semibold text-[#f3ead4] group-hover:text-[#3b9bff] transition-colors">{cleanName(app.name)}</span>
                    </Link>
                  </td>
                  <td className="px-5 py-4 hi-body text-sm text-white/70">{app.category}</td>
                  <td className="px-5 py-4">
                    {app.live ? (
                      <span className="hi-body text-[10px] font-bold uppercase tracking-wider text-[#7fe0a0] bg-[#1f7a45]/25 border border-[#39c274]/40 rounded-full px-2.5 py-1">Live · Beta</span>
                    ) : (
                      <span className="hi-body text-[10px] font-bold uppercase tracking-wider text-[#8fbaff] bg-[#3b9bff]/12 border border-[#3b9bff]/30 rounded-full px-2.5 py-1">Roadmap</span>
                    )}
                  </td>
                  <td className="px-5 py-4 hi-body text-sm text-[#e0bb63]">{app.features?.[0]?.name || "—"}</td>
                  <td className="px-5 py-4">
                    <ul className="space-y-1">
                      {app.features?.slice(0, 3).map((f) => (
                        <li key={f.name} className="hi-body text-xs text-white/65 flex items-center gap-1.5">
                          <Check size={11} className="text-[#4e9d5e] shrink-0" /> {f.name}
                        </li>
                      ))}
                    </ul>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </motion.div>
    </div>
    <div className="relative z-[2]"><Footer /></div>
  </div>
);

export default Compare;
